import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template", "row", "field", "op", "value", "jsonField"]

  connect() {
    // Turbo history restoration reconnects this controller to its cached DOM.
    // Preserve rows already present rather than rebuilding them from JSON.
    if (this.rowTargets.length === 0) this.loadInitialConditions()
    this.updateJson()
  }

  addRow(condition = {}) {
    const content = this.templateTarget.innerHTML
    this.rowsTarget.insertAdjacentHTML("beforeend", content)

    const newRow = this.rowTargets[this.rowTargets.length - 1]

    // Set initial values if provided
    if (condition.field) {
      newRow.querySelector('[data-rule-builder-target="field"]').value = condition.field
    }
    if (condition.op) {
      newRow.querySelector('[data-rule-builder-target="op"]').value = condition.op
    }
    if (condition.value) {
      newRow.querySelector('[data-rule-builder-target="value"]').value = condition.value
    }

    this.updateJson()
  }

  removeRow(event) {
    event.target.closest('[data-rule-builder-target="row"]').remove()
    this.updateJson()
  }

  updateJson() {
    const conditions = this.rowTargets.map(row => ({
      field: row.querySelector('[data-rule-builder-target="field"]').value,
      op: row.querySelector('[data-rule-builder-target="op"]').value,
      value: row.querySelector('[data-rule-builder-target="value"]').value
    }))

    const ui_conditions = { conditions: conditions }

    this.jsonFieldTarget.value = JSON.stringify(ui_conditions)
  }

  loadInitialConditions() {
    let ui_conditions = {}

    try {
      ui_conditions = JSON.parse(this.jsonFieldTarget.value || '{}')
    } catch (e) {
      console.warn("Failed to parse JSON from hidden field", e)
    }

    if (ui_conditions.conditions?.length > 0) {
      ui_conditions.conditions.forEach(c => this.addRow(c))
    } else {
      this.addRow() // Start with one blank row
    }
  }
}
